var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSignedDocument(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 13,
    r: 7,
    fill: "#EBFBF5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0424 11.2269L14.5401 16.6296L11.5293 13.6188L12.7667 12.3813L14.4226 14.0372L17.698 10.1066L19.0424 11.2269Z",
    fill: "#22E295"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 13V1C0 0.447715 0.447715 0 1 0H9.19401C9.45435 0 9.70443 0.101528 9.89109 0.283005L11.6971 2.03883C11.8907 2.22711 12 2.48572 12 2.75582V13C12 13.5523 11.5523 14 11 14H1C0.447715 14 0 13.5523 0 13Z",
    fill: "#DEDCE5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.00006 3.00623H9.00006C9.40243 3.00623 9.72863 3.31963 9.72863 3.70623C9.72863 4.09282 9.40243 4.40623 9.00006 4.40623H3.00006C2.59768 4.40623 2.27148 4.09282 2.27148 3.70623C2.27148 3.31963 2.59768 3.00623 3.00006 3.00623Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.57031 7.00027C2.57031 6.77285 2.76219 6.5885 2.99888 6.5885H6.42746C6.66415 6.5885 6.85603 6.77285 6.85603 7.00027C6.85603 7.22768 6.66415 7.41203 6.42746 7.41203H2.99888C2.76219 7.41203 2.57031 7.22768 2.57031 7.00027Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.00006 6.30042H6.42863C6.83101 6.30042 7.1572 6.61382 7.1572 7.00042C7.1572 7.38701 6.83101 7.70042 6.42863 7.70042H3.00006C2.59768 7.70042 2.27148 7.38701 2.27148 7.00042C2.27148 6.61382 2.59768 6.30042 3.00006 6.30042Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.57031 10.2946C2.57031 10.0672 2.76219 9.88281 2.99888 9.88281H7.2846C7.52129 9.88281 7.71317 10.0672 7.71317 10.2946C7.71317 10.522 7.52129 10.7063 7.2846 10.7063H2.99888C2.76219 10.7063 2.57031 10.522 2.57031 10.2946Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.00006 9.59375H7.28577C7.68815 9.59375 8.01434 9.90715 8.01434 10.2937C8.01434 10.6803 7.68815 10.9937 7.28577 10.9937H3.00006C2.59768 10.9937 2.27148 10.6803 2.27148 10.2937C2.27148 9.90715 2.59768 9.59375 3.00006 9.59375Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignedDocument);
export default __webpack_public_path__ + "static/media/signed-document.8c25523b.svg";
export { ForwardRef as ReactComponent };